import { createContext } from 'react';

import { IUnitedSections } from 'constants/businessToolSections';

import noop from 'helpers/noop';

import { getDefaultLoadingStates } from './utils';

export type ILoadingStates = Record<IUnitedSections, boolean>;
export interface IBusinessToolAiContext {
  isLoading: boolean;
  loadingStates: ILoadingStates;
  isWholeDocumentLoading: boolean;
  generateSectionAI: (sectionName: IUnitedSections) => void;
  cancelSectionAI: ({
    sectionKey,
    onConfirmCallback,
    onAbortCallback,
  }: {
    sectionKey: IUnitedSections;
    onConfirmCallback?: () => void;
    onAbortCallback?: () => void;
  }) => void;
  generateWholeDocument: () => void;
  cancelWholeDocumentAI: (onConfirmCallback?: () => void) => void;
  generateSectionAIImproved: (sectionName: IUnitedSections, callback: () => Promise<void>) => void;
}

const BusinessToolAiContext = createContext<IBusinessToolAiContext>({
  isLoading: false,
  loadingStates: getDefaultLoadingStates(),
  isWholeDocumentLoading: false,
  generateSectionAI: noop,
  cancelSectionAI: noop,
  generateWholeDocument: noop,
  cancelWholeDocumentAI: noop,
  generateSectionAIImproved: noop,
});

export default BusinessToolAiContext;
